<template>
  <v-card
    v-show="value?.length > 0"
    :class="{ transparent: !settings }"
    class="py-3"
    flat
  >
    <v-card-title v-if="!!title" class="text-center justify-center">{{
      title
    }}</v-card-title>
    <p v-if="!!description" class="text-center">{{ description }}</p>
    <v-card-title
      v-if="!newPosition && value && value.length > 1"
      class="flex-wrap justify-center pt-0"
    >
      <v-btn
        :class="gallery === 'allPic' ? 'activeBtn' : ''"
        class="px-3"
        min-width="36"
        text
        @click="gallery = 'allPic'"
      >
        همه
      </v-btn>

      <v-btn
        v-for="({ name }, i) in value"
        :key="i"
        :class="gallery === name ? 'activeBtn' : ''"
        class="px-2"
        min-width="36"
        text
        @click="gallery = name"
      >
        {{ name }}
      </v-btn>
    </v-card-title>

    <v-row v-if="!isGrid && !newPosition" no-gutters>
      <v-col
        v-for="(src, i) in getObj"
        :id="`video.text.wrapper${i}`"
        class="clickable text-center"
        cols="12"
        @click="pdfLoader(src)"
      >
        <v-img v-if="isImg" :aspect-ratio="16 / 9" :src="src.url">
          <div v-if="src.description" class="b-gallery-background">
            <pre
              class="text-center b-service-content pb-2"
              v-html="src.description"
            />

            <div class="b-content-slider" />
          </div>
        </v-img>

        <template v-else>
          <v-card-title
            :id="`video.text${i}`"
            :href="!!src.link ? src.link : null"
            :tag="!!src.link ? 'a' : 'div'"
            class="pa-2 text-no-wrap"
            target="_blank"
            v-html="src.title"
          />
          <iframe :src="src.url || src.file_link" />
          <v-card-text v-show="!!src.description" v-html="src.description" />
        </template>
      </v-col>
    </v-row>

    <v-container v-if="isGrid && !newPosition" fluid grid-list-md>
      <v-layout row wrap>
        <v-flex v-for="(src, i) in getObj" md6 xs12 @click="pdfLoader(src)">
          <v-card>
            <v-img v-if="isImg" :aspect-ratio="16 / 9" :src="src.url" />
            <iframe v-else :src="src.url" />
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container
      v-for="(src, i) in value"
      v-if="isGrid && newPosition"
      fluid
      grid-list-md
    >
      <p>{{ src.name }}</p>
      <v-layout row wrap>
        <v-flex
          v-for="(item, i) in src.images"
          md6
          xs12
          @click="pdfLoader(item)"
        >
          <v-card :href="item.link" color="transparent" flat target="_blank">
            <v-img v-if="isImg" :aspect-ratio="16 / 9" :src="item.url">
              <v-card
                v-if="item.description"
                class="d-flex align-end fill-height px-2"
                color="rgba(0, 0, 0, .3)"
                dark
                flat
              >
                <p v-show="!!src.description" v-html="item.description" />
              </v-card>
            </v-img>
            <iframe
              v-else
              :src="item.url"
              style="max-width: 100%; display: block; margin: auto"
            />
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "bGalleryView",

  props: {
    value: Array,
    title: String,
    description: String,
    isImg: true,
    type: String,
    isGrid: false,
    newPosition: false,
    settings: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    gallery: "allPic",
    status: 0,
  }),

  // mounted() {
  //   setTimeout(() => {
  //     this.getObj.forEach((item, index) => {
  //       this.checkTextOverflow(index)
  //     })
  //   }, 2000)
  // },

  computed: {
    getObj() {
      if (this.gallery === "allPic") {
        let arrays = this.value?.map((item) => item.images);
        return arrays?.reduce((acc, curr) => {
          return acc.concat(curr);
        }, []);
      }

      return this.value?.find((item) => item.name === this.gallery)?.images;
    },
  },

  // watch: {
  //   getObj: {
  //     deep: true,
  //     handler(val) {
  //       console.log('getObj changed: ', val);
  //       this.status = 0
  //     }
  //   }
  // },

  methods: {
    pdfLoader(value) {
      if (this.type === "pdf") {
        window.open(value.link, "_blank");
      }
    },
    // checkTextOverflow(index) {
    //   if (this.status > 1) return
    //
    //   this.$nextTick(() => {
    //     console.log('index: ', index)
    //
    //     let wrapper = document.getElementById(`video.text.wrapper${index}`)
    //     let text = document.getElementById(`video.text${index}`)
    //
    //     if (wrapper) {
    //       let wrapperCliW = wrapper.getClientRects()[0].width
    //       let textCliW = text.getClientRects()[0].width
    //
    //       if (wrapperCliW >= textCliW) {
    //         setTimeout(() => {
    //           this.status += 1
    //           this.checkTextOverflow(index)
    //         }, 5000)
    //       } else if (wrapperCliW < textCliW) {
    //         text.classList.add('set-transition')
    //       }
    //     }
    //   })
    // }
  },
};
</script>

<style scoped>
.ribbon-text-wrapper {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  font-size: 2em;
  max-width: calc(100% - 16px);
}

.ribbon-text-wrapper >>> span {
  display: inline-block;
  transition: all 0.1s linear;
}

.set-transition {
  transform: translateX(-100%);
  animation-delay: 1000s;
  animation: scrolling-text 5s infinite linear;
}

@keyframes scrolling-text {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(100%);
  }
}
</style>

<style lang="scss" scoped>
iframe {
  border: none !important;
}

.activeBtn {
  color: var(--primary);
  border-bottom: 1px solid var(--primary);
}

.b-gallery-background {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  transition: all 0.3s ease-out;
  background-size: cover !important;
  background-position: center !important;

  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 35%;
    width: 100%;
    border-radius: 8px 8px 0 0;
    background: rgba(0, 0, 0, 0.5);
    transition: inherit;
    z-index: 0;
  }

  &:hover {
    &:before {
      height: 100%;
      border-radius: 0;
    }

    div.b-service-content {
      transform: translateY(-20%);
    }

    .b-content-slider {
      visibility: visible;
      width: calc(100% - 32px);
    }
  }

  & > * {
    position: relative;
    z-index: 1;
    color: white;
    transition: inherit;
  }

  .b-content-slider {
    visibility: hidden;
    background: #fff;
    height: 2px;
    border-radius: 10px;
    width: 0;
    margin: 0 auto 16px 16px;
  }
}
</style>
